<template>
  <div :class="`${classVariableName}-progress`">
    <div
      :class="`${colorClass}`"
      :style="{ width: `${percentage}% !important` }"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { classVariableName } from "../../utils";

export default defineComponent({
  name: "progressBarComponent",
  props: {
    percentage: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100,
    },
  },
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  computed: {
    colorClass() {
      return `${this.classVariableName}-bg-default`;
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/Components.scss";
</style>
